<template>
  <CTabs variant="tabs" class="nav-tabs-boxed">
    <CTab title="Transportadoras">
      <Transportadoras />
    </CTab>
    <CTab title="Tipos de Frete">
      <TiposFrete />
    </CTab>
    <CTab title="Tipos de Frete X Transportadora">
      <TiposFreteTransportadora />
    </CTab>
  </CTabs>
</template>

<script>
import { CTab } from "@coreui/vue";
import TiposFrete from "./TiposFrete.vue";
import Transportadoras from "./Transportadoras.vue";
import TiposFreteTransportadora from "./TiposFreteTransportadora.vue";
export default {
  name: "Transporte",
  components: {
    TiposFrete,
    Transportadoras,
    TiposFreteTransportadora
  },
  data() {
    return {};
  },
};
</script>
